export const PLAYGROUND_AUTH_REQUEST = 'anima:playground-auth-request';
export const PLAYGROUND_AUTH_RESPONSE = 'anima:playground-auth-response';
export const PLAYGROUND_ORIGIN = 'https://playground.animaapp.com';

export const getPlaygroundSessionId = (playgroundURL) => {
  if (!playgroundURL) return null;

  try {
    const url = new URL(playgroundURL);
    if (url.origin !== PLAYGROUND_ORIGIN) return null;
    return url.pathname.split('/').filter(Boolean)[0] || null;
  } catch {
    return null;
  }
};

// `getToken` is a callback rather than a value so the JWT is only read once the
// request has been fully validated — an unrelated postMessage never touches it.
export const respondToPlaygroundAuthRequest = ({ event, iframeWindow, playgroundURL, getToken }) => {
  if (!iframeWindow) return false;
  if (event.origin !== PLAYGROUND_ORIGIN || event.source !== iframeWindow) return false;
  if (event.data?.type !== PLAYGROUND_AUTH_REQUEST) return false;

  const sessionId = getPlaygroundSessionId(playgroundURL);
  if (!sessionId || event.data.sessionId !== sessionId) return false;

  const token = getToken();

  iframeWindow.postMessage(
    {
      type: PLAYGROUND_AUTH_RESPONSE,
      sessionId,
      token: typeof token === 'string' && token ? token : null
    },
    PLAYGROUND_ORIGIN
  );
  return true;
};
